export default __webpack_public_path__ + "89ea658dbd64b3754b142f8499cb1132.svg";